import React from 'react';
const guarantees = ['meno stress', 'più organizzazione', 'classi migliori', 'più professionalità'];
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-174">
      <div className="max-w-4xl mx-auto" data-id="element-175">
        <div className="bg-bg-alt border border-primary/40 shadow-[0_0_40px_rgba(242,92,37,0.15)] rounded-sm p-10 sm:p-16 text-center relative overflow-hidden" data-id="element-176">
          <div className="absolute top-0 left-0 w-full h-1 bg-primary" data-id="element-177"></div>
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-primary/5 blur-[60px] pointer-events-none" data-id="element-178"></div>

          <div className="w-24 h-24 mx-auto bg-primary/15 border border-primary/40 rounded-full flex items-center justify-center mb-8 relative" data-id="element-179">
            <span className="text-5xl" data-id="element-180">🛡️</span>
          </div>

          <h2 className="font-display text-3xl sm:text-5xl font-bold text-white mb-6 tracking-tight uppercase" data-id="element-181">
            Risparmia Tempo o Ti Rimborsiamo
          </h2>

          <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto mb-6" data-id="element-182">
            Siamo così sicuri della qualità di{' '}
            <span className="text-white font-bold" data-id="element-183">Functional Pronto</span> che
            ti offriamo:
          </p>

          <p className="font-display text-primary font-bold text-2xl sm:text-3xl mb-8 uppercase tracking-tight" data-id="element-184">
            7 giorni di garanzia totale.
          </p>

          <p className="text-text-sec text-base sm:text-lg mb-4" data-id="element-185">
            Se non senti:
          </p>

          <div className="grid grid-cols-2 gap-3 max-w-md mx-auto mb-8" data-id="element-186">
            {guarantees.map((g, i) => <div key={i} className="flex items-center gap-2 bg-bg-card border border-border-light rounded-sm px-4 py-3 text-left" data-id="element-187">
                <span className="text-check-green flex-shrink-0" data-id="element-188">✓</span>
                <span className="text-white text-sm font-medium" data-id="element-189">{g}</span>
              </div>)}
          </div>

          <p className="text-white text-lg sm:text-xl font-medium" data-id="element-190">
            ti restituiamo il{' '}
            <span className="text-primary font-bold" data-id="element-191">100% dei tuoi soldi</span>.
            Senza domande.
          </p>
        </div>
      </div>
    </section>;
}